module.exports = __webpack_public_path__ + "static/beans01-d68a3f90d80e95ab988989c6b791be71.png";